import React from "react";
import { Link } from "react-router-dom";

import bg1 from '../../assets/images/bg/bg-services.png'
import bg2 from '../../assets/images/bg/bg-lines-two.png'
import business from '../../assets/images/svg/business-plan.svg'
import phone from '../../assets/images/phone.png'
import Navbar from "../../components/navbar";
import CompanyLogo from "../../components/companyLogo";
import { TbBolt, TbPentagon, FiArrowRight, MdOutlineCheckCircle, TbMailStar } from '../../assets/icons/icons'
import { clientData, featureTwo, pricingThree } from "../../data/data";

import TinySlider from "tiny-slider-react";
import 'tiny-slider/dist/tiny-slider.css';
import Blog from "../../components/blog";
import Footer from "../../components/footer";
import ScrollTop from "../../components/scrollTop";

export default function IndexServices(){

    let settings ={
        container: '.tiny-two-item',
        controls: false,
        mouseDrag: true,
        loop: true,
        rewind: true,
        autoplay: true,
        autoplayButtonOutput: false,
        autoplayTimeout: 3000,
        navPosition: "bottom",
        speed: 400,
        gutter: 12,
        responsive: {
            992: {
                items: 2
            },

            767: {
                items: 2
            },

            320: {
                items: 1
            },
        },
    } 

    return(
        <>
        <Navbar navLight={true}/>

        <section className="bg-half-170 d-table w-100 bg-primary" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
            <div className="container">
                <div className="row mt-5 align-items-center">
                    <div className="col-lg-7 col-md-6">
                        <div className="heading-title">
                            <h6 className="text-white-50">Services</h6>
                            <h4 className="heading text-white title-dark mb-3">Space service that <br/> moves work forward</h4>
                            <p className="para-desc text-white-50">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                            
                            <div className="mt-4">
                                <Link to="#" className="btn btn-soft-light-alt">Learn More</Link>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-5 col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0">
                        <div className="mx-auto bg-white p-4 rounded shadow-lg ms-lg-5">
                            <h4 className="form-title mb-4">Get Started Free</h4>
                            <form>
                                <div className="mb-3 position-relative">
                                    <label className="form-label">Name <span className="text-danger">*</span></label>
                                    <input name="name" id="name" type="text" className="form-control" placeholder="Name :"/>
                                </div>

                                <div className="mb-3 position-relative">
                                    <label className="form-label">Email <span className="text-danger">*</span></label>
                                    <input name="email" id="email" type="email" className="form-control" placeholder="Email :"/>
                                </div>

                                <div className="mb-3 position-relative">
                                    <label className="form-label">Password</label>
                                    <input type="password" id="password1" className="form-control mb-2" placeholder="Password :"/>
                                </div>

                                <div className="d-grid">
                                    <button className="btn btn-primary">Get Started</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section className="py-5 bg-light">
            <div className="container">
                <CompanyLogo/>
            </div>
        </section>

        <section className="section">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-md-6">
                        <img src={phone} className="img-fluid" alt=""/>
                    </div>

                    <div className="col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0">
                        <div className="ms-lg-5">
                            <div className="section-title">
                                <span className="badge rounded-pill bg-soft-primary">Features</span>
                                <h4 className="title mt-3 mb-4">Analyze your data with <br/> our analysis tools.</h4>
                                <p className="text-muted para-desc mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                            </div>
    
                            <div className="row">
                                <div className="col-md-6 mt-4 pt-2">
                                    <div className="card features feature-primary bg-transparent border-0">
                                        <div className="icon text-center rounded-md text-primary">
                                            <h3 className="mb-0"><TbBolt /></h3>
                                        </div>
                                        <div className="card-body p-0 mt-4">
                                            <h5>Unlimited Power</h5>
                                            <p className="text-muted mb-0">Composed in a pseudo-Latin language which more or less corresponds.</p>
                                        </div>
                                    </div>
                                </div>
    
                                <div className="col-md-6 mt-4 pt-2">
                                    <div className="card features feature-primary bg-transparent border-0">
                                        <div className="icon text-center rounded-md text-primary">
                                            <h3 className="mb-0"><TbPentagon /></h3>
                                        </div>
                                        <div className="card-body p-0 mt-4">
                                            <h5>Professional Design</h5>
                                            <p className="text-muted mb-0">Composed in a pseudo-Latin language which more or less corresponds.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
    
                            <div className="mt-4 pt-2">
                                <Link to="#" className="btn btn-soft-primary">Try for free <FiArrowRight className="fea icon-sm"/></Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-6 order-1 order-md-2">
                        <img src={business} className="img-fluid" alt=""/>
                    </div>

                    <div className="col-lg-6 col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0 order-2 order-md-1">
                        <div className="me-lg-5">
                            <div className="section-title">
                                <span className="badge rounded-pill bg-soft-primary">Company</span>
                                <h4 className="title mt-3 mb-4">We create world-class <br/> web design, and branding.</h4>
                                <p className="text-muted para-desc">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                            
                                <ul className="list-unstyled text-muted">
                                    <li className="mb-0 ms-0"><span className="text-primary h5 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Digital Marketing Solutions for Tomorrow</li>
                                    <li className="mb-0 ms-0"><span className="text-primary h5 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Our Talented & Experienced Marketing Agency</li>
                                    <li className="mb-0 ms-0"><span className="text-primary h5 me-2"><MdOutlineCheckCircle className="align-middle"/></span>Create your own skin to match your brand</li>
                                </ul>
                                <div className="mt-4">
                                    <Link to="#" className="btn btn-primary">Learn more</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="section-title text-center mb-4 pb-2">
                            <h6 className="text-primary">Services</h6>
                            <h4 className="title mb-4">Explore about our awesome features</h4>
                            <p className="para-desc mx-auto text-muted mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>

                <div className="row justify-content-center">
                    <div className="col-lg-10 mt-4">
                        <ul className="list-unstyled text-center mb-0">
                            {featureTwo.map((item,index) =>{
                                let Icon = item.icon
                                return(
                                    <li className="list-inline-item m-2" key={index}>
                                        <div className="d-flex key-feature feature-primary align-items-center rounded-lg shadow py-2 px-3">
                                            <div className="icon text-center rounded-circle me-3">
                                                <Icon className="fea icon-ex-md"/>
                                            </div>
                                            <h5 className="mb-0 title">{item.title}</h5>
                                        </div>
                                    </li>
                                )
                            })}
                        </ul>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row">
                    <div className="col-12">
                        <div className="section-title mb-4 pb-2">
                            <h4 className="title mb-4">Client's Review</h4>
                            <p className="para-desc text-muted mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <div className="tiny-two-item">
                            <TinySlider settings={settings}>
                                {clientData.map((item, index) =>{
                                    return(
                                        <div className="tiny-slide" key={index}>
                                            <div className="card border-0 customer-testi p-4 pt-5 shadow rounded-md m-2 overflow-hidden">
                                                <p className="text-muted fst-italic">{item.desc}</p>
                                                <div className="d-flex align-items-center mt-3">
                                                    <img src={item.image} className="img-fluid avatar avatar-small rounded-circle shadow" alt=""/>
                                                    <div className="flex-1 ms-3">
                                                        <h6 className="text-primary mb-0">{item.name}</h6>
                                                        <small className="text-muted">{item.title}</small>
                                                    </div>
                                                </div>
                                                <div className="quote">
                                                    <i className="mdi mdi-format-quote-close"></i>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </TinySlider>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="section-title text-center mb-4 pb-2">
                            <h6 className="text-primary">Pricing</h6>
                            <h4 className="title mb-4">Flexible pricing for any services</h4>
                            <p className="para-desc mx-auto text-muted mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>

                <div className="row">
                    {pricingThree.map((item,index) =>{
                        return(
                        <div className="col-lg-4 col-md-6 mt-4 pt-2" key={index}>
                            <div className="card pricing text-center shadow rounded-md border-0">
                                <div className="card-body p-4">
                                    <span className="py-2 px-4 d-inline-block bg-soft-primary h6 mb-0 text-primary rounded-lg">{item.title}</span>
        
                                    <div className="d-flex justify-content-center my-4">
                                        <span className="h5 mb-0 mt-2">$</span>
                                        <span className="price h1 mb-0">{item.amount}</span>
                                        <span className="h5 align-self-end mb-1"> / month</span>
                                    </div>
        
                                    <Link to="#" className="btn btn-primary">{item.btn}</Link>
                                    <div className="plan-features h6 mb-0 mt-4">
                                        <p>Bandwidth : <span className="text-primary">{item.band}</span></p>
                                        <p>Onlinespace : <span className="text-primary">{item.space}</span></p>
                                        <p className="mb-0">Support : <span className="text-primary">{item.support}</span></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        )
                    })}
                    <div className="col-12 text-center">
                        <p className="text-muted mt-4 mb-0">*No credit card required</p>
                    </div>
                </div>
            </div>

            <div className="container-fluid px-0 mt-100 mt-60">
                <div className="px-4 py-5 bg-primary" style={{backgroundImage:`url(${bg2})`, backgroundPosition:'center'}}>
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-md-8">
                                <div className="section-title">
                                    <div className="d-flex">
                                        <TbMailStar className="display-4 text-white title-dark"/>
                                        <div className="flex-1 ms-md-4 ms-3">
                                            <h4 className="fw-bold text-light title-dark mb-1">Subscribe to our newsletters</h4>
                                            <p className="text-white-50 mb-0">Sign up and receive the latest tips via email.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
    
                            <div className="col-md-4 mt-4 mt-sm-0">
                                <div className="text-md-end ms-5 ms-sm-0">
                                    <Link to="#" className="btn btn-soft-light-alt">Subscribe Now</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container mt-100 mt-60">
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="section-title text-center mb-4 pb-2">
                            <h6 className="text-primary">News</h6>
                            <h4 className="title mb-4">Read some amazing case studies.</h4>
                            <p className="text-muted para-desc mx-auto mb-0">Explore and learn more about everything from machine learning and global payments to  scaling your team.</p>
                        </div>
                    </div>
                </div>
                <Blog/>
            </div>
        </section>
        <Footer/>
        <ScrollTop/>
        </>
    )
}